
import React from "react";
import {Sparkles} from "lucide-react";
import {Button} from "antd";
import {Link} from "react-router-dom";

export default function TeacherStatCard({label, value, sub, color, link, linkTitle}) {
    const colors = {
        blue: 'bg-blue-50 border-blue-300 dark:bg-blue-950/40 dark:border-blue-800',
        emerald: 'bg-emerald-50 border-emerald-300 dark:bg-emerald-950/40 dark:border-emerald-800',
        amber: 'bg-amber-50 border-amber-300 dark:bg-amber-950/40 dark:border-amber-800',
        red: 'bg-red-50 border-red-300 dark:bg-red-950/40 dark:border-red-800',
    }[color];

    const textColors = {
        blue: 'text-blue-700 dark:text-blue-300',
        emerald: 'text-emerald-700 dark:text-emerald-300',
        amber: 'text-amber-700 dark:text-amber-300',
        red: 'text-red-700 dark:text-red-300',
    }[color];

    return (
        <Link to={link}>
            <div className={`rounded-2xl border p-4 ${colors}`}>
                <div className={`flex justify-between items-center ${textColors}`}>
                    <div>
                        <p className="text-sm mb-1">{label}</p>
                    </div>
                </div>

                <p className={`text-3xl font-bold ${textColors}`}>{value}</p>

                <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">{sub}</p>

                <Button className="my-2" type="dashed" size="small">
                    <div className="text-xs flex gap-1 items-center">
                        <Sparkles size={14} className="text-blue-500 dark:text-blue-300"/>
                        <span className="text-blue-800 dark:text-blue-200">{linkTitle}</span>
                    </div>
                </Button>
            </div>
        </Link>
    );
}
